const splitConfig = {
    lines: {
        duration: 0.8,
        stagger: 0.08
    },
    words: {
        duration: 0.6,
        stagger: 0.06
    },
    chars: {
        duration: 0.4,
        stagger: 0.01
    }
};

const typesToSplit = {
    lines: ['lines'],
    words: ['lines', 'words'],
    chars: ['lines', 'words', 'chars']
};

const markRevealScheduled = new WeakSet();
const markRevealDelay = 0.75;
const markRevealStagger = 0.75;

export function headingSplit() {
    document.fonts.ready.then(() => {
        const headings = document.querySelectorAll('[data-split="heading"]');

        if (!headings.length) return;

        headings.forEach((heading) => {
            const requestedType = heading.dataset.splitReveal || 'lines';
            const requestedDelay = parseFloat(heading.dataset.splitDelay);
            const delay = Number.isNaN(requestedDelay) ? 0 : requestedDelay;
            const revealsMark = heading.hasAttribute('data-mark-reveal');
            const hasMark = Boolean(heading.querySelector('mark'));
            const hero = heading.closest('[data-front-hero]');

            const type = Object.hasOwn(splitConfig, requestedType)
                ? requestedType
                : 'lines';

            gsap.set(heading, {
                autoAlpha: 1
            });

            SplitText.create(heading, {
                type: typesToSplit[type].join(','),
                mask: 'lines',
                autoSplit: true,
                linesClass: 'line',
                wordsClass: 'word',
                charsClass: 'letter',

                onSplit(instance) {
                    const targets = instance[type];
                    const config = splitConfig[type];

                    instance.lines.forEach((line) => {
                        const mask = line.parentElement;
                        mask.classList.add('split-line-mask');
                        if (hasMark) {
                            // Replace SplitText's inline clipping with the expanded CSS window.
                            mask.style.overflow = 'visible';
                        }
                    });

                    gsap.set(heading, {
                        autoAlpha: 1
                    });

                    return gsap.from(targets, {
                        yPercent: hasMark ? 150 : 110,
                        rotation: +15,
                        transformOrigin: 'left bottom',
                        force3D: true,
                        duration: hero ? 0.5 : config.duration,
                        stagger: hero ? 0.05 : config.stagger,
                        delay,
                        ease: 'expo.out',
                        onStart: () => {
                            hero?.classList.add('is-title-started');
                        },
                        onComplete: () => {
                            if (hasMark) {
                                instance.lines.forEach((line) => {
                                    line.parentElement.style.clipPath = 'none';
                                });
                            }
                            if (!revealsMark || markRevealScheduled.has(heading)) return;

                            markRevealScheduled.add(heading);

                            gsap.delayedCall(hero ? 0.15 : markRevealDelay, () => {
                                const marks = [...heading.querySelectorAll('mark')];

                                marks.forEach((mark, index) => {
                                    gsap.delayedCall(index * (hero ? 0.2 : markRevealStagger), () => {
                                        mark.classList.add('is-mark-revealed');

                                        if (index === marks.length - 1) {
                                            heading.classList.add('are-marks-revealed');
                                        }
                                    });
                                });
                            });
                        },
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 80%',
                            once: true
                        }
                    });
                }
            });
        });
    });
}
